import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {
  CHANGE,
  COMPLETE, FAIL
} from '@megaphonenpm/mputils/src/constants.js';
import {notNil} from '@megaphonenpm/mputils/src/utils.js';
import {log} from '@megaphonenpm/mputils/src/logfunctions.js';
import {get} from 'lodash-es';
import {PRODUCTNAME_SCOREBOARD, SCENE_TYPE_PREDICTION} from './constants.js';
import {UpdateRankingsTask} from './UpdateRankingsTask.js';

/**
 * Loads all rankings for the current playlist, and assigns each loaded ranking list to the supplied
 * dataStore.
 */
export class LoadRankingsTask extends Task {
  constructor (dataStore) {
    super();
    this.name = 'LOAD_RANKINGS';
    this.numRankingsToLoad = 0;
    this.numRankingLoadAttemptsResolved = 0;
    this.dataStore = dataStore;
    this.changedRankingIDs = null;
  }

  start () {
    super.start();

    let rankingsToLoad = [];
    this.changedRankingIDs = [];
    let scenes = this.dataStore.playlist.scenes;
    if (notNil(scenes)) {
      scenes.forEach(scene => {
        let rankingSourceID = get(scene, 'content.src.id');
        let sceneType = get(scene, 'type');
        let productName = get(scene, 'presentation.screen_product.name');
        if (notNil(rankingSourceID)
            && sceneType === SCENE_TYPE_PREDICTION
            && productName.toLowerCase() === PRODUCTNAME_SCOREBOARD) {
          rankingsToLoad.push({rankingSourceID: rankingSourceID, sceneType: sceneType});
        }
      });
    }

    this.numRankingsToLoad = rankingsToLoad.length;
    this.numRankingLoadAttemptsResolved = 0;

    if (this.numRankingsToLoad === 0) {
      log('No scoreboard scenes in current playlist. No rankings loaded.');
      this.done();
    } else {
      log(`Loading ${this.numRankingsToLoad} rankings...`);
      rankingsToLoad.forEach(rankingToLoad => {
        let updateRankingsTask = new UpdateRankingsTask(rankingToLoad.rankingSourceID, this.dataStore, rankingToLoad.sceneType);
        updateRankingsTask.on(COMPLETE, () => {
          log(`Loaded ranking [${rankingToLoad.rankingSourceID}]`);
          this.numRankingLoadAttemptsResolved++;
          this.handleRankingLoadAttemptResolved();
        });
        updateRankingsTask.on(CHANGE, () => {
          log(`Ranking changed [${rankingToLoad.rankingSourceID}]`);
          this.changedRankingIDs.push(rankingToLoad.rankingSourceID);
        });
        updateRankingsTask.on(FAIL, () => {
          log(`Failed to load ranking [${rankingToLoad.rankingSourceID}]`);
          this.numRankingLoadAttemptsResolved++;
          this.handleRankingLoadAttemptResolved();
        });
        updateRankingsTask.start();
      });
    }
  }

  handleRankingLoadAttemptResolved () {
    if (this.numRankingLoadAttemptsResolved === this.numRankingsToLoad) {
      log('All rankings loaded.');
      this.done();
    }
  }
}
